import { useState } from 'react';
import { useSearchParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import {
  Box, Paper, TextField, Button, Typography,
  IconButton, InputAdornment, Alert, Stack, Container, Link
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const SetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    try {
      await axiosInstance.post('/user/set-password', {
        token,
        password,
      });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 5000);
    } catch (err) {
      setError(err.response?.data?.message || 'エラーが発生しました');
    }
  };

  if (!token) {
    return (
      <Container maxWidth="sm">
        <Typography mt={6}>このリンクはすでに無効になっています。<br />
          お手数ですが、<Link component={RouterLink} to="/contact">お問い合わせページ</Link>
          よりメールの再送信をご依頼ください。</Typography>
      </Container>
    );
  }

  if (success) {
    return (
      <Container maxWidth="sm">
        <Typography mt={6} align='center'>
          パスワードが設定されました。<br />
          <Link component={RouterLink} to="/login">ログインページ</Link>へ移動します。
        </Typography>
      </Container>
    );
  }

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 4,
            bgcolor: 'background.paper',
            borderRadius: 2,
          }}
        >
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2.5}>
              <Typography variant="h5" fontWeight="bold">
                パスワード設定
              </Typography>

              <Typography variant="body2" color="text.secondary">
                8文字以上のパスワードを設定してください
              </Typography>

              <TextField
                label="新しいパスワード"
                type={passwordVisible ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                size='medium'
                required
                inputProps={{ maxLength: 128 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setPasswordVisible(v => !v)}>
                        {passwordVisible ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="確認用パスワード"
                type={confirmPasswordVisible ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                size='medium'
                inputProps={{ maxLength: 128 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setConfirmPasswordVisible(v => !v)
                        }
                      >
                        {confirmPasswordVisible ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {error && <Alert severity="error">{error}</Alert>}

              <Box display="flex" justifyContent="center" mt={3}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ width: 200 }}
                >
                  保存
                </Button>
              </Box>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};

export default SetPasswordPage;
